import { normalizeLang } from "../i18n";

function safeDecode(value) {
  if (!value) return "";
  try {
    return decodeURIComponent(value);
  } catch {
    return String(value || "");
  }
}

function ensureLang(path, fallbackLang) {
  try {
    const url = new URL(path, "https://innervoice.local");
    if (!url.searchParams.get("lang")) {
      url.searchParams.set("lang", normalizeLang(fallbackLang || "he"));
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return `/journey?lang=${normalizeLang(fallbackLang || "he")}`;
  }
}

export function resolvePostAuthTarget(rawNext, fallbackLang = "he") {
  const safeLang = normalizeLang(fallbackLang || "he");
  const fallback = `/journey?lang=${safeLang}`;
  const next = safeDecode(rawNext).trim();

  if (!next || !next.startsWith("/") || next.startsWith("//")) {
    return fallback;
  }

  if (next.startsWith("/auth/")) {
    return fallback;
  }

  return ensureLang(next, safeLang);
}
